import '../App.css';
import Swal from 'sweetalert2';
import { AiFillDelete } from "@react-icons/all-files/ai/AiFillDelete";
import { useSelector, useDispatch } from 'react-redux';
import {
    updateObject,
    deleteRelationship
} from '../features/metadata/MetadataLogic'
import React, { useEffect, useState } from 'react';

export default function ModalOverlayGestionObjetos(props) {

    const dispatch = useDispatch()
    const project = useSelector((state) => state.project)

    const nodos = project.timeLines[props.timeLineID].nodes;
    const relaciones = project.timeLines[props.timeLineID].edges;

    const [selectedObject, setSelectedObject] = useState(0);

    function handleObjectChange(event) {
        setSelectedObject(event.target.value)
    }

    // ------------------------------------------------------------------------------------------------------------------

    // True: Visible, False: invisible (switch)
    const [selectedVisibility, setSelectedVisibility] = useState();

    function handleVisibilityChange(event) {
        setSelectedVisibility(!selectedVisibility)
    }

    function handleDeleteRelationship(id) {
        dispatch(deleteRelationship({ timeLineID: props.timeLineID, id: id }))
    }

    useEffect(() => {
        relaciones.toReversed().forEach((obj) => {
            if (obj.relType == 'ind_obj')
                return setSelectedObject(obj.from)
        });
    }, [])



    useEffect(() => {
        if (nodos[selectedObject].hidden) {
            setSelectedVisibility(true)
        } else {
            setSelectedVisibility(false)
        }
    }, [selectedObject])

    return (
        <div className="overlay">
            <div className="modalCustomizado">
                <div className="container text-center aling-items-start" >
                    <h2 style={{ fontFamily: "Segoe UI", color: "#232323" }}>Gestionar objetos de la linea temporal</h2>

                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center g-2">
                            <div className="mt-3">
                                <select className="form-select form-select-md" value={selectedObject} onChange={e => handleObjectChange(e)}>
                                    {
                                        nodos.map((item) => {
                                            if (item.type == 'object') {
                                                return <option key={item.id} value={item.id}> {item.label}</option>
                                            }
                                        })
                                    }
                                </select>

                            </div>

                            {/* Titulos */}
                            <div className="row justify-content-center align-items-center g-2">
                                <div className="col mt-3">
                                    <h4>Metadatos del Objeto</h4>
                                </div>
                            </div>

                            {/* Metadatos */}
                            <div className="col">
                                <div class="row justify-content-center align-items-center mb-3">
                                    <div class="col-md-4">
                                        <label for="visibility">Visibilidad</label>
                                    </div>
                                    <div className="col-md-2" style={{ marginLeft: '14%', }}>
                                        <div className="form-check form-switch" style={{ width: "50px" }}>
                                            <input className="form-check-input" type="checkbox" role="switch" checked={!selectedVisibility} onChange={handleVisibilityChange} style={{ width: "45px", height: "25px" }} title={(selectedVisibility && 'Invisible') || 'Visible'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row justify-content-center align-items-end">
                        <div className="col-2">
                            <button type="button" className="btn btn-primary" onClick={() => {

                                let dispatchData = {
                                    nodeID: selectedObject,
                                    hidden: selectedVisibility
                                }

                                dispatch(updateObject({
                                    timeLineID: props.timeLineID, nodeID: dispatchData.nodeID,
                                    hidden: dispatchData.hidden
                                }))

                                dispatch(updateObject({
                                    timeLineID: props.timeLineID, nodeID: dispatchData.nodeID - 1,
                                    hidden: dispatchData.hidden,
                                    color: {
                                        border: '#000000',
                                        background: 'hsla(0, 0%, 100%, 0)',
                                    },
                                }))

                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 3000,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener('mouseenter', Swal.stopTimer)
                                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                                    }
                                })
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Objeto actualizado con éxito'
                                })
                            }}>Aplicar</button>
                        </div>
                        <div className="col-2">
                            <button onClick={props.onClose} className="btn btn-danger">Cerrar</button>
                        </div>
                    </div>

                </div>

            </div >
        </div >
    );
}

